/* SprinJene Morocco — French collection currency cleanup */
(function(){
  if(!document.querySelector('main[data-template^="collection"]')) return;
  const isFrench=(document.documentElement.lang||'').toLowerCase().startsWith('fr');
  if(!isFrench) return;
  const normalize=function(root){
    const scope=root&&root.querySelectorAll?root:document;
    scope.querySelectorAll('main[data-template^="collection"] .facets *').forEach(function(el){
      if(el.children.length===0 && el.textContent && el.textContent.indexOf('د.م.')!==-1){
        el.textContent=el.textContent.replace(/د\.م\./g,'dh');
      }
    });
    scope.querySelectorAll('main[data-template^="collection"] .facets input').forEach(function(input){
      if(input.placeholder&&input.placeholder.indexOf('د.م.')!==-1){
        input.placeholder=input.placeholder.replace(/د\.م\./g,'dh');
      }
    });
  };
  normalize(document);
  const target=document.querySelector('main[data-template^="collection"]');
  if(!target) return;
  let raf=0;
  const observer=new MutationObserver(function(){
    cancelAnimationFrame(raf);
    raf=requestAnimationFrame(function(){normalize(target)});
  });
  observer.observe(target,{childList:true,subtree:true,characterData:true});
})();
